import React from "react";
import Card from "../../components/Career/Card";
const Career = () => {
  return (
    <>
      <div className="container py-lg-5 py-md-4 py-3">
        <div className="row">
          <h1 className="text-dark-beetroot text-center">Join Our Team</h1>
          <hr className="main-hr" />
        </div>
        <div className="row">
          {/* <Card
  jp="Customer Support Executive (Voice Process)"
  location="India"
  eligibility="1–3 years of experience in international voice-based customer support or a related customer service role."
  skills={[
    "Excellent verbal communication skills in English with a clear and professional speaking style.",
    "Experience handling inbound and outbound calls for international customers.",
    "Strong customer-handling skills with the ability to resolve queries, complaints, and issues effectively.",
    "Good understanding of customer service principles and call center etiquette.",
    "Ability to work in rotational shifts, including night shifts, as required for international campaigns.",
    "Basic computer knowledge and experience working with CRM or ticketing tools is a plus.",
  ]}
  Preferred_Qualifications={[
    "Prior experience in international BPO or voice process campaigns.",
    "Ability to handle high call volumes while maintaining service quality.",
    "Strong listening, problem-solving, and interpersonal skills.",
    "Customer-focused mindset with a positive and professional attitude.",
  ]}
  link="mailto:anshika.pandey@techtorch.solutions?subject=Job Application - Customer Support Executive (Voice)&body=Dear HR Team,%0D%0A%0D%0AI would like to apply for the Customer Support Executive (Voice Process) position. Please find my resume attached.%0D%0A%0D%0ARegards,"
 /> */}

          </div>
          <div className="row mt-2">
          {/* <Card
  jp="Customer Support Executive (Chat Process)"
  location="India"
  eligibility="6 months to 2 years of experience in international chat-based customer support or a related customer service role."
  skills={[
    "Excellent written communication skills in English with strong grammar and typing accuracy.",
    "Experience handling customer interactions via live chat, email, or messaging platforms.",
    "Ability to manage multiple chat conversations simultaneously while maintaining response quality.",
    "Strong problem-solving skills to understand customer issues and provide effective resolutions.",
    "Familiarity with CRM systems, ticketing tools, or chat support platforms.",
    "Basic computer proficiency and comfort working in a fast-paced digital support environment.",
  ]}
  Preferred_Qualifications={[
    "Prior experience in international chat or non-voice BPO campaigns.",
    "Ability to work in rotational shifts, including night shifts, as required for international clients.",
    "Strong attention to detail and quick comprehension skills.",
    "Customer-centric mindset with a calm and professional approach.",
  ]}
  link="mailto:anshika.pandey@techtorch.solutions?subject=Job Application - Customer Support Executive (Chat)&body=Dear HR Team,%0D%0A%0D%0AI would like to apply for the Customer Support Executive (Chat Process) position. Please find my resume attached.%0D%0A%0D%0ARegards,"
 /> */}

        </div>

         <div className="row mt-2">
{/* <Card
  jp="Data Entry Specialist"
  location="India"
  eligibility="1 year of experience in data entry, data processing, or an administrative support role."
  skills={[
    "Strong data entry skills with high accuracy and attention to detail.",
    "Proficiency in MS Excel, Google Sheets, and basic data management tools.",
    "Ability to enter, update, and maintain large volumes of data efficiently.",
    "Good understanding of data confidentiality and information security practices.",
    "Basic computer knowledge with the ability to work independently and meet deadlines.",
    "Strong organizational skills and a methodical approach to work.",
  ]}
  Preferred_Qualifications={[
    "Previous experience in domestic data entry or back-office operations.",
    "Familiarity with databases, CRM systems, or ERP tools.",
    "Ability to handle repetitive tasks while maintaining accuracy and consistency.",
    "Good communication skills and a responsible work ethic.",
  ]}
  link="mailto:anshika.pandey@techtorch.solutions?subject=Job Application - Data Entry Specialist&body=Dear HR Team,%0D%0A%0D%0AI would like to apply for the Data Entry Specialist position. Please find my resume attached.%0D%0A%0D%0ARegards,"
 /> */}


         </div>

          <div className="row mt-2">

{/* <Card
  jp="Back End Specialist"
  location="India"
  eligibility="1 year of experience in back-end operations, process support, or technical support roles within a BPO or service-based environment."
  skills={[
    "Experience handling high-volume data processing and back-end operational tasks in a BPO setting.",
    "Ability to support system integrations, internal tools, and backend workflows used for service delivery.",
    "Strong understanding of process automation, data validation, and quality checks.",
    "Hands-on experience with databases, spreadsheets, or backend systems for data updates and reporting.",
    "Ability to monitor backend processes to ensure accuracy, continuity, and service availability.",
    "Basic troubleshooting skills to identify and escalate system or process-related issues.",
  ]}
  Preferred_Qualifications={[
    "Previous experience working in a BPO or shared services environment.",
    "Understanding of SLA-driven operations and 24/7 service support models.",
    "Familiarity with process improvement, automation tools, or workflow management systems.",
    "Strong attention to detail with the ability to work under time-sensitive conditions.",
  ]}
  link="mailto:anshika.pandey@techtorch.solutions?subject=Job Application - Back End Specialist&body=Dear HR Team,%0D%0A%0D%0AI would like to apply for the Back End Specialist position. Please find my resume attached.%0D%0A%0D%0ARegards,"
 /> */}

          </div>

           <div className="row mt-2">

<Card
  jp="Software Engineer Trainee (Intern)"
  location="India"
  eligibility="Fresher or final-year student with a strong interest in software development and learning modern technologies."
  skills={[
    "Basic understanding of programming concepts using languages such as JavaScript, Python, Java, or similar.",
    "Fundamental knowledge of web technologies including HTML, CSS, and basic frontend or backend concepts.",
    "Willingness to learn frameworks, tools, and best practices used in real-world software development.",
    "Basic understanding of databases and data handling concepts is a plus.",
    "Ability to write clean, readable code and follow guidance from senior developers.",
    "Good problem-solving skills and a positive learning attitude.",
  ]}
  Preferred_Qualifications={[
    "Pursuing or recently completed a degree in Computer Science, IT, or a related field.",
    "Exposure to React, Node.js, or any modern development framework is an added advantage.",
    "Basic familiarity with Git or version control concepts.",
    "Strong communication skills and the ability to work collaboratively in a team environment.",
  ]}
  link="mailto:anshika.pandey@techtorch.solutions?subject=Internship Application - Software Engineer Trainee&body=Dear HR Team,%0D%0A%0D%0AI would like to apply for the Software Engineer Trainee (Intern) position. Please find my resume attached.%0D%0A%0D%0ARegards,"
 />

           </div>
      </div>
    </>
  );
};

export default Career;
